/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { INutritionist } from 'app/shared/model/nutritionist.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { FeedType } from 'app/shared/model/enumerations/feed-type.model';
import { EntralType } from 'app/shared/model/enumerations/entral-type.model';
import { MealType } from 'app/shared/model/enumerations/meal-type.model';

export interface IMeal {
  id?: string;
  name?: string | null;
  tag?: string | null;
  description?: string | null;
  feedType?: keyof typeof FeedType | null;
  entralType?: keyof typeof EntralType | null;
  mealType?: keyof typeof MealType | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  weight?: number;
  wightUnits?: string;
  price?: number | null;
  createdBy?: INutritionist;
  modifiedMeal?: INutritionist;
  hospital?: IHospital;
}

export const defaultValue: Readonly<IMeal> = {
  active: false,
};
